import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from 'react-router-dom';
import './i18n';

const App = React.lazy(() => import('./App'));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <React.Suspense fallback={''}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Suspense>
    {/* </React.StrictMode> */}
  </Provider>
);

// Optional
reportWebVitals();
